
import React from "react";

import Main from "./Main/main";
import Header from "./Header/header";



function Profile() {
    return (
        <div>
        <Header/>
            <Main />
        </div>
    );
}

export default Profile;
